/* eslint-disable @typescript-eslint/no-unused-expressions */
import { EnvService } from "@/services/Environment/Environment";
import { isNoxusInternal } from "@/utils/isNoxusInternal";

// Typescript global window type
declare global {
  interface Window {
    sessionRewind: any;
    SessionRewindConfig: any;
  }
}

const config = (
  userEmail: string,
  userName: string,
  sessionRewindToken: string
) => {
  return {
    apiKey: sessionRewindToken,
    startRecording: false,
    onLoad: () => {
      window.sessionRewind.stopSession();

      window.sessionRewind.identifyUser({
        userId: userEmail,
        userName: userName,
        isInternal: false,
      });

      window.sessionRewind.startSession();
    },
  };
};

export const launchSessionReview = (userEmail: string, userName: string) => {
  const SESSION_REWIND_TOKEN = EnvService.getVar("SESSION_REWIND_TOKEN");
  if (!SESSION_REWIND_TOKEN) return;
  const environment = EnvService.getVar("DEPLOYMENT_ENV");

  const BLACKLIST_EMAILS = [
    "ribeiralves@gmail.com",
    "pedroallenrevez@gmail.com",
  ];

  //If dev env or internal user
  if (
    environment !== "prod" ||
    isNoxusInternal(userEmail) ||
    BLACKLIST_EMAILS.includes(userEmail)
  ) {
    return;
  }

  const w = window;
  w.SessionRewindConfig = config(userEmail, userName, SESSION_REWIND_TOKEN);
  const f = document.createElement("script");
  ((f.async = true),
    (f.crossOrigin = "anonymous"),
    (f.src = "https://rec.sessionrewind.com/srloader.js"));

  const g = document.getElementsByTagName("head")[0];
  g.insertBefore(f, g.firstChild);
};
